import { render, staticRenderFns } from "./folders-table.vue?vue&type=template&id=ca328b8c"
import script from "./folders-table.ts?vue&type=script&lang=js&external"
export * from "./folders-table.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports